import * as React from "react";

const SvgReplay = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillOpacity={0.92}
      d="M17.714 6.286H6.286V8.72L4 10.857V4h16v12.571H8.571V20L4 15.429l4.571-4.572v3.429h9.143z"
    />
  </svg>
);
export default SvgReplay;
